import React, { useEffect, useMemo, useState } from "react";
import { MaterialReactTable } from "material-react-table";
import Button from "@mui/material/Button";
import api from "./Axios/api";
import { useNavigate } from "react-router-dom";
import { MenuItem, Select, InputLabel, FormControl } from "@mui/material";
import { useSelector } from "react-redux";
import { IndianRupee, Trash2 } from "lucide-react";
import Swal from "sweetalert2";
import Loader from "../components/common/Loader";
const Report = () => {
  const [reportData, setReportData] = useState([]);
  const [selectedFactory, setSelectedFactory] = useState("");
  const [factoryList, setFactoryList] = useState([]);
  const [rawData, setRawData] = useState([]);
  const [isloading, setIsLoading] = useState(false);

  const userRole = useSelector((state) => state.user.staff_role);
  const currentStaffFacLoc = useSelector((state) => state.user.staff_FacLoc);

  const navigate = useNavigate();

  const handleFactoryChange = (event) => {
    setSelectedFactory(event.target.value);
  };

  const filterFun = (data, selectedFactory) => {
    const filteredData = [];

    data.forEach((entry) => {
      const date = entry.date;

      // CONSUMPTION
      entry.consumption?.forEach((voucher) => {
        let totalConsumption = 0;

        voucher.consume_items?.forEach((consume) => {
          if (consume.godown === selectedFactory) {
            consume.items?.forEach((item) => {
              totalConsumption += parseFloat(item.amount || 0);
            });
          }
        });

        if (totalConsumption > 0) {
          filteredData.push({
            date,
            voucherNo: voucher.voucherNo,
            totalAmount: `${totalConsumption.toFixed(2)} || 0`,
            info: "Consumption Info",
          });
        }
      });

      // PRODUCTION
      entry.production?.forEach((voucher) => {
        let totalProduction = 0;

        voucher.consume_items?.forEach((consume) => {
          if (consume.godown === selectedFactory) {
            consume.items?.forEach((item) => {
              totalProduction += parseFloat(item.amount || 0);
            });
          }
        });

        if (totalProduction > 0) {
          filteredData.push({
            date,
            voucherNo: voucher.voucherNo,
            totalAmount: `0 || ${totalProduction}`,
            info: "Production Info",
          });
        }
      });
    });

    setReportData(filteredData);
  };
  let allowedFactories = [];

  const extractFactoryNames = (data) => {
    if (userRole === "666c0f8ebeca5ab2c65b35a9") {
      allowedFactories = [
        "POLYBOND INSULATION",
        "POLYBOND PROJECTS",
        "POLYBOND ROCKFIBRE",
      ];
    } else {
      const facLocMap = {
        "666c0f5ebeca5ab2c65b2c85": ["POLYBOND INSULATION"],
        "666c0f5ebeca5ab2c65b2c86": ["POLYBOND PROJECTS"],
      };

      allowedFactories = facLocMap[currentStaffFacLoc] || [
        "POLYBOND ROCKFIBRE",
      ];
    }
    const factories = new Set();

    data.forEach((entry) => {
      entry.consumption?.forEach((voucher) => {
        voucher.consume_items?.forEach((item) => {
          const name = item.godown?.toUpperCase();
          if (allowedFactories.includes(name)) {
            factories.add(name);
          }
        });
      });
      entry.production?.forEach((voucher) => {
        voucher.consume_items?.forEach((item) => {
          const name = item.godown?.toUpperCase();
          if (allowedFactories.includes(name)) {
            factories.add(name);
          }
        });
      });
    });

    return Array.from(factories);
  };

  const fetchData = async () => {
    try {
       setIsLoading(true);
      const res  = await api(`consumption/get-consumptions`);
      const sortedData = res.data.sort((a,b)=>new Date(b.date)- new Date(a.date));
      // console.log("da", data);
      setRawData(sortedData);
       setIsLoading(false);

      const factories = extractFactoryNames(sortedData);
      setFactoryList(factories);
      if (factories.length > 0) {
        setSelectedFactory(factories[0]);
        filterFun(sortedData, factories[0]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleDelete = async () => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this.. ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (selectedFactory) {
      filterFun(rawData, selectedFactory);
    }
  }, [selectedFactory]);

  const columns = useMemo(
    () => [
      {
        accessorKey: "date",
        header: "Date",
         Cell: ({ cell }) => new Intl.DateTimeFormat("en-GB").format(new Date (cell.getValue())),
      },
      {
        accessorKey: "voucherNo",
        header: "Voucher No.",
      },
      {
        accessorKey: "totalAmount",
        header: "Total Amount",
        Cell: ({ cell }) => `₹ ${cell.getValue()}`,
      },
      {
        accessorKey: "info",
        header: "Info",
        Cell: ({ row }) => (
          <Button
            variant="contained"
            size="small"
            onClick={() =>
              navigate(
                `/report-info/${row.original.date}/${row.original.voucherNo}/${selectedFactory}`
              )
            }
          >
            Info
          </Button>
        ),
      },
      {
        header: "Status",
        size: 80,

        Cell: () => (
          <div className="flex items-center ml-3 cursor-pointer">
            <Trash2
              className="w-6 h-6 text-red-600"
              onClick={() => {
                handleDelete();
              }}
            />
          </div>
        ),
      },
    ],
    [reportData]
  );

  return (
    <div className="w-full flex flex-col items-center">
      <div className="w-[38%] mt-4 mb-4 bg-white">
        <FormControl fullWidth>
          <InputLabel id="factory-select-label">Select Factory</InputLabel>
          <Select
            labelId="factory-select-label"
            value={selectedFactory}
            label="Select Factory"
            onChange={handleFactoryChange}
          >
            {factoryList.map((factory, idx) => (
              <MenuItem key={idx} value={factory}>
                {factory}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
      <div className="w-[98%]">
         {  isloading ? ( <Loader/>):(
        <MaterialReactTable
          columns={columns}
          data={reportData || []}
          enableRowSelection
        />
         )}
      </div>
    </div>
  );
};

export default Report;
